module.exports = __webpack_public_path__ + "img/settings-icon.605dbf3c.png";